import url from '../url'
import headers from '../headers'
import moment from 'moment'

export default {
	getAll (context, user_uid, watch_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/?size=${size}`,
			headers.bearer()
		)
	},
	getUpcoming (context, user_uid, watch_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/upcoming/?size=${size}`,
			headers.bearer()
		)
	},
	getAllByDates (context, user_uid, watch_id, date_start, date_end) {
		// UTC format and encoded URI
		date_start = encodeURIComponent(moment(date_start).format())
		date_end = encodeURIComponent(moment(date_end).format())
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/between-dates/?start=${date_start}&end=${date_end}`,
			headers.bearer()
		)
	},
	getAllForToday (context, user_uid, watch_id, date) {
		// UTC format and encoded URI
		let date_start = encodeURIComponent(moment(date).format())
		let date_end = encodeURIComponent(moment(date).add(1, 'd').subtract(1, 'seconds').format())
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/between-dates/?start=${date_start}&end=${date_end}`,
			headers.bearer()
		)
	},
	getUpcoming (context, user_uid, watch_id, date, size = 5) {
		// UTC format and encoded URI
		let date_start = encodeURIComponent(moment(date).format())
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/upcoming/?start=${date_start}&size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id, id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/${id}/`,
			headers.bearer()
		)
	},
	add (context, user_uid, watch_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/${model.id}/`,
			model,
			headers.bearer()
		)
	},
	delete (context, user_uid, watch_id, id) {
		return context.$http.delete(
			`${url}/users/${user_uid}/watches/${watch_id}/calendar/${id}/`,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/appointments.js